import { action, observable, makeObservable, computed } from 'mobx';
import { Views, View } from 'react-big-calendar';

import {
  ICalendarAccount,
  ICalendarAuthAccount,
  ICalendarEvent,
} from 'APP/model/calendar/calendar.types';

export interface IInitialCalendarParams {
  accounts: ICalendarAuthAccount[];
  eventsMap: { [key: string]: ICalendarEvent[] | null } | null;
  currentDate: Date | null;
  currentView: View;
}
export class Calendar {
  @observable public isCompactViewEnabled = false;
  @observable public isLoading = true;
  @observable public accounts: ICalendarAuthAccount[] = [];
  @observable public calendarInstancesCount = 0;
  @observable public eventsMap: { [key: string]: ICalendarEvent[] | null } | null = null;
  @observable public currentDate: Date | null = null;
  @observable public currentView: View = Views.WEEK;

  constructor() {
    makeObservable(this);
  }

  @computed
  get isActiveAccount(): boolean {
    return this.accounts.some((account) => account.isActive);
  }

  @computed
  get initialCalendarParams(): IInitialCalendarParams {
    return {
      accounts: this.accounts,
      currentDate: this.currentDate,
      currentView: this.currentView,
      eventsMap: this.eventsMap,
    };
  }

  @computed
  get activeCalendarAccounts(): ICalendarAccount[] {
    return this.initialCalendarParams.accounts
      .filter((authAccount) => authAccount.isActive)
      .map((authAccount) => authAccount.account);
  }

  @action
  setLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }

  @action
  setIsCompactViewEnabled(isCompactViewEnabled: boolean): void {
    this.isCompactViewEnabled = isCompactViewEnabled;
  }

  @action
  setAccounts(accounts: ICalendarAuthAccount[]): void {
    this.accounts = accounts;
  }

  @action
  setEventsMap(eventsMap: { [key: string]: ICalendarEvent[] | null } | null): void {
    this.eventsMap = eventsMap;
  }

  @action
  setCurrentDate(currentDate: Date | null): void {
    this.currentDate = currentDate;
  }

  @action
  setCurrentView(currentView: View): void {
    this.currentView = currentView;
  }

  @action increaseCalendarInstancesCount(): void {
    this.calendarInstancesCount += 1;
  }

  @action decreaseCalendarInstancesCount(): void {
    this.calendarInstancesCount = Math.max(0, this.calendarInstancesCount - 1);
  }

  @action resetCalendarAccounts(): void {
    this.accounts = [];
  }
}
